/**
 * Password complexity validation.
 *
 * @module procedural/passwordValidation
 */

import * as constants from '../constants';

/**
 * Validate password complexity.
 *
 * Requires at least MIN_PASSWORD_LENGTH characters, an uppercase letter,
 * a lowercase letter, a digit, and a special character.
 *
 * @param {string} pw - The password to validate.
 * @returns {boolean} True if the password meets all requirements.
 */
export function isPasswordComplex(pw) {
  if (pw.length < constants.MIN_PASSWORD_LENGTH) return false;
  if (!/[A-Z]/.test(pw))                         return false;
  if (!/[a-z]/.test(pw))                         return false;
  if (!/[0-9]/.test(pw))                         return false;
  if (!/[^A-Za-z0-9]/.test(pw))                  return false;
  return true;
}
